import { render } from "./PasswordResetLink.vue?vue&type=template&id=0b9edb72"
import script from "./PasswordResetLink.vue?vue&type=script&lang=ts"
export * from "./PasswordResetLink.vue?vue&type=script&lang=ts"
script.render = render

export default script